module.exports = () => ({
  ".base-block": { "@apply ds-w-full ds-flow-root": 1 },

  ".base-block-background-container": {
    "@apply ds-relative ds-overflow-clip ds-max-w-[1920px] ds-mt-2xl ds-mb-3xl ds-mx-auto lg:!ds-mt-3xl lg:!ds-mb-4xl": 1,
  },

  ".base-block-background-container-compact": {
    "@apply ds-relative ds-overflow-clip ds-max-w-[1920px] ds-mx-auto": 1,
  },

  ".base-block-module-container": {
    "@apply ds-max-w-4xl ds-mx-auto ds-px-lg md:!ds-px-3xl": 1,
  },

  ".base-block-grid-cols-2": {
    "@apply ds-grid ds-grid-cols-1 ds-gap-xl sm:!ds-grid-cols-2 lg:!ds-gap-4xl": 1,
  },

  ".base-block-grid-cols-3": {
    "@apply ds-grid ds-grid-cols-1 ds-gap-xl sm:!ds-grid-cols-2 lg:!ds-grid-cols-3 lg:!ds-gap-2xl": 1,
  },

  ".base-block-grid-cols-4": {
    "@apply ds-grid ds-grid-cols-1 ds-gap-xl sm:!ds-grid-cols-2 lg:!ds-grid-cols-4 lg:!ds-gap-2xl": 1,
  },
});
